/**
 * セッションの状態から、次に何をするかを決める（Issue #8078）。
 *
 * **純粋関数にするのが目的。** 元は effect の中の入れ子分岐で、どの条件でどれが走るのか
 * 読み取れなかった。ここを関数にすると、条件の組み合わせを表として読める。
 *
 * | status | id | 行き先 |
 * |---|---|---|
 * | `unauthenticated` | — | `clear` |
 * | `authenticated` | 有る | `load` |
 * | `authenticated` | 無い | `sign-out-corrupted`（session callback が落ちている） |
 * | `loading` | 有る | `wait`（`status` が決まるまで触らない） |
 * | `loading` | 無い | `clear`（まだ誰でもない） |
 *
 * **引数は `status` と「id が有るか」の 2 つだけ。** 以前は `sessionUserId` も受けていたが、
 * 呼び出し側はどちらも `session?.user?.id` から渡すので、独立した入力ではなかった。
 * 2 つ受けると「片方だけ true」という**実際には起き得ない組み合わせ**をテストできてしまい、
 * 到達不能な分岐を通ったつもりになる（レビュー指摘で実際にそうなっていた）。
 *
 * `loading` で id が有るときに何もしないのは、**確定前の断面で状態を書き換えないため**。
 */
export function resolveSessionAction(
  status: 'authenticated' | 'unauthenticated' | 'loading',
  hasUserId: boolean,
): 'clear' | 'sign-out-corrupted' | 'load' | 'wait' {
  if (status === 'unauthenticated') return 'clear';
  // **`authenticated` なのに id が無いのは、id 欠落より先に見る**（レビュー指摘）。
  // 逆順にすると `sign-out-corrupted` へ到達できない ── 呼び出し側は id の有無を
  // 1 つの値から渡すので、「id が無い」で先に `clear` へ落ちてしまう。
  if (status === 'authenticated') return hasUserId ? 'load' : 'sign-out-corrupted';
  // `loading`。id がまだ無いなら空にし、有るなら確定を待つ。
  return hasUserId ? 'wait' : 'clear';
}
